// extracted by mini-css-extract-plugin
export default {"paper":"MessageForm_paper__nV6qs"};